<template>
  <div class="wait-confirm-bill">
    <div>
      <!-- 表格-->
      <el-table
        :loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :max-height="300"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="serialNum"
          label="序号"
        >
        </el-table-column>
        <el-table-column
          prop="pushTime"
          label="结算单推送日期"
        >
        </el-table-column>
        <el-table-column
          prop="purchaseCorpName"
          label="采购公司"
          width="200"
        >
        </el-table-column>
        <el-table-column
          prop="settleNo"
          label="结算单号"
          width="200"
        >
          <template slot-scope="scope">
            <span class="blue" @click="loadAccountDetail(scope.row.settleNo)">{{scope.row.settleNo}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="settleDate"
          label="结算单生成日期"
        >
        </el-table-column>
        <el-table-column
          prop="purchaseTotalAmount"
          label="采购总金额"
        >
        </el-table-column>
        <el-table-column
          prop="refundTotalAmount"
          label="退货总金额"
        >
        </el-table-column>
        <el-table-column
          prop="unSettleTotalAmount"
          label="待结算总金额"
        >
        </el-table-column>
        <el-table-column
          prop="settleStatus"
          label="结算单状态"
        >
          <template slot-scope="scope">
            <span>{{scope.row.settleStatus | filterSettleStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="handleBtn('confirm', scope.row)"
              type="text"
              size="small"
              :disabled="scope.row.serialNum !== 1"
            >
              确认
            </el-button>
            <el-button
              @click.native.prevent="handleBtn('appeal', scope.row)"
              type="text"
              size="small"
              :disabled="scope.row.serialNum !== 1"
            >
              申诉
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 50, 100, 200]"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
    <!-- 账单详情表格-->
    <detail-table ref="detailTable"/>
    <!-- 账单申诉弹窗-->
    <el-dialog
      class="settle-modal"
      :visible.sync="appealBillDialog"
      width="30%"
      :append-to-body="true"
    >
       <span slot="title" class="dialog-title">
        <span class="title">账单申诉</span>
      </span>
      <span slot="footer" class="dialog-footer">
           <el-button class="btn" @click="handleClose('appeal')">取消</el-button>
           <el-button type="primary" @click="handleBtn('confirmAppeal')" :loading="appealLoading">确认</el-button>
      </span>
      <div class="form-wrapper">
        <div>
          <span class="label">店铺名称</span>
          <span class="value">{{shopName}}</span>
        </div>
        <div>
          <span class="label">结算单号</span>
          <span class="value">{{singleItem.settleNo}}</span>
        </div>
        <div>
          <span class="label"><span style="color:#FF5023">*</span>申诉原因</span>
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="appealReason"
            maxlength="100"
            show-word-limit
          >
          </el-input>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DetailTable from "./detailTable";
export default {
  props: {
    tableData: Array,
    loading: Boolean,
    handleSizeChange: Function,
    handleCurrentChange: Function,
    currentPage: Number,
    pageSize: Number,
    totalCount: Number,
    handleSelectionChange: Function,
    selectKeys: Array,
    goAccountConfirm: Function,
    goAccountAppeal: Function,
  },
  components: {
    DetailTable
  },
  data() {
    return {
      shopName: localStorage.getItem('username'),
      detailLoading: false,
      detailData: [],
      orderDialogVisible: false,
      appealBillDialog: false,
      appealReason: '',
      singleItem: {
        settleNo: ''
      },
      originalOrderList: [],
      deductionOrderList: [],
      appealLoading: false,
    }
  },
  filters: {
    filterSettleStatus(type) {
      console.log(type, "type");
      let text = "";
      switch (type) {
        case 1:
          text = "新建";
          break;
        case 2:
          text = "已支付";
          break;
        case -1:
          text = "取消";
          break;
        case 3:
          text = "待确认";
          break;
        case 4:
          text = "申诉中";
          break;
        case 5:
          text = "已确认";
          break;
        case 6:
          text = "已推送";
          break;
        case 7:
          text = "推送失败";
          break;
      }
      return text;
    }
  },
  methods: {
    // 关闭弹窗
    handleClose(type) {
      switch (type) {
        case 'appeal':
          this.appealBillDialog=false;
          break;
        case 'originOrderModal':
          this.orderDialogVisible=false;
          break;
      }
    },
    //按钮处理
    handleBtn(type, record) {
      switch (type) {
        case 'confirm':
          this.goAccountConfirm([record]);
          break;
        case 'appeal':
          this.appealBillDialog=true;
          this.appealReason = null;
          this.singleItem = record;
          break;
        case 'confirmAppeal':
          if(!this.appealReason) {
            this.$message.error("请填写申诉原因");
            return;
          }
          this.appealLoading = true;
          this.goAccountAppeal(this.appealReason, this.singleItem);
          break;
        case 'lookOrder':
          this.goOriginalOrder(record.salesOrderNo);
          break;
      }
    },
    loadAccountDetail(settleNo) {
      this.$refs.detailTable.loadAccountDetail(settleNo);
    },
    clearDetail() {
      this.$refs.detailTable.detailData = [];
    }
  }
}
</script>
<style lang="scss" scoped>
.wait-confirm-bill {
  .detail-title {
    font-size: 12px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #333333;
    margin-bottom: 6px;
  }
  .blue {
    color: #236BDC;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/r4SettlementReport/billConfirm/components/waitConfirmBill.vue